module.exports = __webpack_public_path__ + "img/zones.29af35a6.svg";